import SignaturePad from 'signature_pad';
import trimCanvas from 'trim-canvas';

// eslint-disable-next-line no-promise-executor-return
const delay = ms => new Promise(res => setTimeout(res, ms));

export default class AdivareSignaturePad {
  constructor(config, canvas) {
    this.signatureConfig = config;
    this.signatureObject = new SignaturePad(canvas, config);

    this.canvasToDataURL();
    this.prepareCanvas();
  }

  prepareCanvas() {
    if (500 >= window.innerWidth) {
      this.signatureObject._ctx.width = 250;
      this.signatureObject._ctx.height = 160;
    } else {
      this.signatureObject._ctx.width = 400;
      this.signatureObject._ctx.height = 250;
    }

    this.signatureObject._ctx.font = 'normal 5em \'Alex Brush\'';
  }

  nameToSignature(firstName, lastName) {
    const value = [firstName, lastName].reduce((text, name) => {
      // IDE wont stop telling me false === can be simplified to !
      if ('string' !== typeof name && !(name instanceof String)) {
        // Argument is not a string, go on to the next.
        return text || '';
      }

      // Add a space before adding a new word.
      return (`${text || ''} ${name}`).trim();
    });

    return this.drawLetters(value);
  }

  drawLetters(value) {
    if ('' === value) {
      // Only draw letters if there are letters.
      // Make sure a Promise is always returned
      return new Promise(res => {
        res(this.canvasToDataURL());
      });
    }
    let measureValue = value;
    if (0 === value.replace(/^\s+|\s+$/g, '').length) {
      measureValue = '.';
    }
    const canvas = this.signatureObject._canvas;
    const context = this.signatureObject._ctx;
    let xPoint = (canvas.width / 2) - (context.measureText(measureValue).width / 2);
    const yPoint = (canvas.height / 2) + 5;

    if (0 > xPoint) {
      xPoint = 15;
    }

    return this.fillText(context, canvas, value, xPoint, yPoint, canvas.width - 30);
  }

  fillText(context, canvas, text, x, y, maxWidth) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async res => {
      // Wait for the font to be loaded.
      // eslint-disable-next-line no-await-in-loop
      while (!document.fonts.check(context.font)) await delay(5);

      // Draw empty to set correct font etc.
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.fillText(text, x, y, maxWidth);
      context.save();

      res(this.canvasToDataURL());
    });
  }

  canvasToDataURL() {
    const canvas = this.signatureObject._canvas;

    const cloneCanvas = document.createElement('canvas');
    const cloneContext = cloneCanvas.getContext('2d');

    cloneCanvas.width = canvas.width;
    cloneCanvas.height = canvas.height;

    cloneContext.drawImage(canvas, 0, 0);
    trimCanvas(cloneCanvas);

    return cloneCanvas.toDataURL('image/png');
  }

  toData() {
    return this.signatureObject.toData();
  }

  fromData(data) {
    this.signatureObject.fromData(data);
  }

  isEmpty() {
    return this.signatureObject.isEmpty();
  }

  clear() {
    this.signatureObject.clear();
  }
}
